import { quillEditor } from 'vue-quill-editor';
import { addQuillTitle } from './quill-title.js';
import Quill from 'quill';

// 自定义插入a链接
var Link = Quill.import('formats/link');
class FileBlot extends Link {
  // 继承Link Blot
  static create(value) {
    let node;
    if (value && !value.href) {
      // 适应原本的Link Blot
      node = super.create(value);
    } else {
      // 自定义Link Blot
      node = super.create(value.href);
      node.setAttribute('download', value.innerText); // 左键点击即下载
      node.innerText = value.innerText;
      node.download = value.innerText;
    }
    return node;
  }
}
FileBlot.blotName = 'link';
FileBlot.tagName = 'A';
Quill.register(FileBlot);

export default {
  components: { quillEditor },
  data() {
    return {
      // editor
      editorOption: {
        placeholder: this.$t('inputText'),
        theme: 'snow', // or 'bubble'
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
              ['blockquote', 'code-block'], // 引用  代码块
              [{ header: 1 }, { header: 2 }], // 1、2 级标题
              [{ script: 'sub' }, { script: 'super' }], // 上标/下标
              [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
              ['link', 'image'], // 链接、图片、视频
            ], // 工具栏
            handlers: {
              image: function (value) {
                this.myEdit = this.quill;
                if (value) {
                  document.querySelector('.avatar-uploader input').click();
                } else {
                  this.quill.format('image', false);
                }
              },
            },
          },
        },
      },
      customQuestionList: {}, // 父组件传过来的数据,
      quillEditorFileList: [], // 富文本编辑器上传的图片
      uillUpdateImg: false,
      myEdit: null,
      fileUpload: '',
    };
  },
  mounted() {
    addQuillTitle();
  },
  methods: {
    afterUpload(url) {
      // 获取光标所在位置
      const quill = this.$refs.myQuillEditor.quill;
      const length = quill.getSelection().index;
      // 插入图片
      const quillUrl = 'http://' + url;
      if (this.isImageLink(url)) {
        quill.insertEmbed(length, 'image', quillUrl);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        const fileNameLength = quillUrl.length;
        quill.insertEmbed(length, 'link', { href: quillUrl, innerText: quillUrl }, 'api');
        quill.setSelection(length + fileNameLength);
      }
    },
    isImageLink(url) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']; // 可以根据需要添加更多图片格式
      const urlSplit = url.split('.');
      const urlExtension = urlSplit[urlSplit.length - 1];
      return imageExtensions.includes(urlExtension.toLowerCase());
    },
    onEditorChange({ editor, html, text }) {},
    // 编辑器获得光标
    onEditorFocus(editor) {
      this.myEdit = editor;
      editor.enable(true);
    },
    // 富文本编辑器上传
    uploadQuillEditor(files) {
      if (this.quillEditorFileList.length > 0) {
        this.quillEditorFileList.splice(0, 1);
      }
      this.uploadCoverImg(files);
    },
  },
};
